import React from 'react';
import './Table.css';

const Table = ({ data }) => {
  // Early return if data is not properly structured
  if (!data?.datasets || !data?.labels) {
    return <div>No data available</div>;
  }

  return (
    <div className="table-container">
      <table className="chart-table">
        <thead>
          <tr>
            <th></th>
            {data.datasets.map(dataset => (
              <th key={dataset.label}>{dataset.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.labels.map((label, rowIndex) => (
            <tr key={label}>
              <td>{label}</td>
              {data.datasets.map((dataset, colIndex) => (
                <td key={`${label}-${dataset.label}`}>
                  ${dataset.data[rowIndex].toLocaleString()}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
